import { Box, Button, Link } from "@mui/material";

export interface SaveBarProps {
  changeCount: number;
  errorCount: number;
  isSubmitting: boolean;
  onDiscard: () => void;
  onSave: () => Promise<void> | void;
  onJumpToFirstError?: () => void;
}

export const SaveBar = ({ changeCount, errorCount, isSubmitting, onDiscard, onSave, onJumpToFirstError }: SaveBarProps) => {
  const disabled = isSubmitting || changeCount === 0 || errorCount > 0;
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        py: 1,
        borderTop: "1px solid #222",
      }}
    >
      <Box sx={{ fontSize: 13, color: "#aaa", display: "inline-flex", alignItems: "center", gap: 1.5 }}>
        <span>
          {changeCount === 0
            ? "No changes"
            : `${changeCount} change${changeCount === 1 ? "" : "s"} pending`}
        </span>
        {errorCount > 0 && (
          <Link
            component="button"
            type="button"
            onClick={() => onJumpToFirstError?.()}
            sx={{
              color: "#ff1744",
              fontWeight: 700,
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <span style={{ fontWeight: 900 }}>⚠</span>
            {errorCount} {errorCount === 1 ? "error" : "errors"} — jump to first
          </Link>
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          onClick={onDiscard}
          disabled={changeCount === 0 || isSubmitting}
          sx={{ color: "#fff", "&.Mui-disabled": { color: "rgba(255,255,255,0.35)" } }}
        >
          Discard
        </Button>
        <Button
          disabled={disabled}
          onClick={() => onSave()}
          sx={{
            color: "#66bb6a",
            "&:hover": { backgroundColor: "rgba(102,187,106,0.08)" },
            "&.Mui-disabled": { color: "rgba(102,187,106,0.35)" },
          }}
        >
          {isSubmitting ? "Saving…" : `Save changes${changeCount > 0 ? ` (${changeCount})` : ""}`}
        </Button>
      </Box>
    </Box>
  );
};
